import React from 'react'
import Contribute from '../../Components/ContributePageComponent.js/Contribute'


const ContributePage = ({ active }) => {
    return (
        <div className='h-screen'>
            <Contribute active={active} />
        </div>
    )
}

export default ContributePage